import { PlusCircle } from "@phosphor-icons/react";
import { useState } from "react";

import { LinkedInLoginModal } from "common/components/LinkedInLogin";
import { Button } from "common/components/ui/Button";

import NoAccountImage from "assets/images/empty-placeholders/template-preview-no-account.png";

//if the user doesn't have any linkedin accounts, this placeholder is displayed instead of the template preview
export default function TemplatePreviewPlaceholder() {
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);

  return (
    <>
      <div className="flex flex-col justify-center items-center flex-1 rounded-3xl border border-black-200 lg:basis-1/2 p-4">
        <img src={NoAccountImage} alt="" className="max-w-72" />
        <h4 className="text-lg-bold mb-2">No accounts</h4>
        <p className="text-black-500 text-sm-medium mb-4 text-center">
          Preview will be available after you add a LinkedIn account
        </p>
        <Button
          size="sm"
          leftIcon={<PlusCircle weight="fill" />}
          onClick={() => setIsLoginModalOpen(true)}
        >
          Connect account
        </Button>
      </div>
      <LinkedInLoginModal
        isOpen={isLoginModalOpen}
        onClose={() => setIsLoginModalOpen(false)}
      />
    </>
  );
}
